import { MISSION_HOME } from "@/lib/auth-callback";
import {
  isAuthBypassMode,
  isBrowserProductionAuthHost,
  useAuthHealth,
  type AuthHealth,
} from "@/lib/auth-health";
import { Navigate } from "react-router-dom";

export function useSkipLoginGate(): {
  skip: boolean;
  health: AuthHealth;
  loaded: boolean;
  productionHost: boolean;
} {
  const { health, loaded } = useAuthHealth();
  return {
    skip: loaded && isAuthBypassMode(health),
    health,
    loaded,
    productionHost: isBrowserProductionAuthHost(),
  };
}

/** Client-side belt for `/` `/login` `/register` when Worker HTML intercept is skipped. */
export function AuthBypassRedirect() {
  const { skip } = useSkipLoginGate();
  if (!skip) return null;
  return <Navigate to={MISSION_HOME} replace />;
}
